import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=6e941022&"
import script from "./UserSettings.vue?vue&type=script&lang=js&"
export * from "./UserSettings.vue?vue&type=script&lang=js&"
import style0 from "./UserSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports